module.exports = __webpack_public_path__ + "img/117ne.93ca2152.svg";